// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"70ce7e5d","703":"53d2c649"}[chunkId] + ".chunk.js";
};